import { useCallback, useEffect } from "react";
import { $getSelection, $isRangeSelection, LexicalEditor } from "lexical";
import { $patchStyleText } from "@lexical/selection";
import { FONT_SIZE_OPTIONS } from "../../../config/constants";
import AscDropdown from "../../../../AscDropdown/AscDropdown";
import styles from "./FontSizeDropDown.module.scss";

export function FontSizeDropDown({
  editor,
  value,
  disabled = false,
}: {
  editor: LexicalEditor;
  value: string;
  disabled?: boolean;
}): JSX.Element {
  const handleClick = useCallback(
    (option: string) => {
      if (editor._rootElement) {
        editor._rootElement.dataset.fontSize = option;
      }
      editor.update(() => {
        const selection = $getSelection();
        if ($isRangeSelection(selection)) {
          $patchStyleText(selection, {
            ["font-size"]: option,
          });
        }
      });
    },
    [editor]
  );

  useEffect(() => {
    if (editor._rootElement) {
      editor._rootElement.dataset.fontSize = value;
      editor._rootElement.style.fontSize = value;
    }
  }, [value]);
  return (
    <AscDropdown
      disabled={disabled}
      titleContainerClassName={styles["title"]}
      variant="secondary"
      title={value}
    >
      {FONT_SIZE_OPTIONS.map(([option, text]) => (
        <AscDropdown.Option
          active={value === option}
          onClick={() => handleClick(option)}
          key={option}
        >
          {text}
        </AscDropdown.Option>
      ))}
    </AscDropdown>
  );
}
